export default __webpack_public_path__ + "static/nrc_irap-8cdeb269f9650a09f95e5d95c6263fc3.png";